import { PageTabed } from '@components-common/layouts';
import { ConfigElement } from '@components-fabric';
import { ScreenProps } from '@components-common/types';
import { mapView } from './view';
import { mapToolbar } from './toolbar';
import { mapForm } from './form';
import { TabbedPage } from '../../../components-common/tabs/TabbedPage';

export const mapEditTabScreen = (config:ConfigElement, context: ScreenProps) => {
  context.type = "edit";
  const result = {
    type: "edit",
    view: {
      ...mapView(config,context),
      Component: TabbedPage,
      ...{props: {
        toolbar: mapToolbar(config,context),
        form: mapForm(config as any,context),
        tabs: (config as any).tabs
      }}
    }
  };
  return result;
}
